export default __webpack_public_path__ + "static/media/ELECTIVE_WOODWORKING.2cc2bf65.svg";